import {
  GET_ALL_INVOICE_HEADER_LINE_REQUEST,
  GET_ALL_INVOICE_HEADER_LINE_SUCCESS,
  GET_ALL_INVOICE_HEADER_LINE_ERROR,
  DELETE_INVOICE_HEADER_LINE_ERROR,
  DELETE_INVOICE_HEADER_LINE_SUCCESS,
  DELETE_INVOICE_HEADER_LINE_REQUEST,
  GET_ONE_INVOICE_HEADER_LINE_REQUEST,
  GET_ONE_INVOICE_HEADER_LINE_SUCCESS,
  GET_ONE_INVOICE_HEADER_LINE_ERROR,
  ADD_INVOICE_HEADER_LINE_REQUEST,
  ADD_INVOICE_HEADER_LINE_SUCCESS,
  ADD_INVOICE_HEADER_LINE_ERROR,
  GET_ONE_INVOICE_HEADER_LINE_DETAIL_REQUEST,
  GET_ONE_INVOICE_HEADER_LINE_DETAIL_SUCCESS,
  GET_ONE_INVOICE_HEADER_LINE_DETAIL_ERROR,
} from "./types";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const getAllOrderShipmentLine = (token) => (dispatch) => {
  dispatch({ type: GET_ALL_INVOICE_HEADER_LINE_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/invoiceLine`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      startDate: "1-1-2022",
      endDate: "1-31-2022",
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_ALL_INVOICE_HEADER_LINE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_ALL_INVOICE_HEADER_LINE_ERROR,
        payload: error.response,
      });
    });
};

export const addInvoiceHeaderLine = (token, object) => (dispatch) => {
  dispatch({ type: ADD_INVOICE_HEADER_LINE_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}create/invoiceLine`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: object,
  })
    .then((response) => {
      return dispatch({
        type: ADD_INVOICE_HEADER_LINE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: ADD_INVOICE_HEADER_LINE_ERROR,
        payload: error.response,
      });
    });
};

export const getOneInvoiceLine = (token, id) => (dispatch) => {
  dispatch({ type: GET_ONE_INVOICE_HEADER_LINE_REQUEST });
  return axios({
    method: "GET",
    url: `${BASEURL}getOne/invoiceLine/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_ONE_INVOICE_HEADER_LINE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_ONE_INVOICE_HEADER_LINE_ERROR,
        payload: error.response,
      });
    });
};

export const getOneInvoiceLineDetail = (token, id) => (dispatch) => {
  dispatch({ type: GET_ONE_INVOICE_HEADER_LINE_DETAIL_REQUEST });
  return axios({
    method: "GET",
    url: `${BASEURL}getOne/getInvoiceLineDetail/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_ONE_INVOICE_HEADER_LINE_DETAIL_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_ONE_INVOICE_HEADER_LINE_DETAIL_ERROR,
        payload: error.response,
      });
    });
};

export const deleteInvoiceLine = (token, data, id) => (dispatch) => {
  dispatch({ type: DELETE_INVOICE_HEADER_LINE_REQUEST });

  
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	

  return axios({
    method: "DELETE",
    url: `${BASEURL}delete/invoiceLine/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { data: data }
  })
    .then((response) => {
      return dispatch({
        type: DELETE_INVOICE_HEADER_LINE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: DELETE_INVOICE_HEADER_LINE_ERROR,
        payload: error.response,
      });
    });
};
